import { keepPreviousData, useQuery, useQueryClient } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
const urlPrefix = "/plugins/org.graylog.plugins.archive";
const url = (path) => qualifyUrl(`${urlPrefix}${path}`);
const errorMessageFor = (error) => {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = error.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.message) != null ? _c : error.message) != null ? _d : "Some fields are not valid.";
};
export const ARCHIVE_BACKENDS_QUERY_KEY = ["archive-backends"];
export const ARCHIVE_BACKEND_QUERY_KEY = ["archive-backend"];
const fetchBackends = (page, perPage) => fetch("GET", url(`/backends?page=${page}&per_page=${perPage}`)).then((response) => ({
  backends: response.backends,
  pagination: {
    count: response.count,
    total: response.total,
    page: response.page,
    per_page: response.per_page,
    query: response.query
  }
})).catch((error) => {
  UserNotification.error(
    `Fetching archive backends failed: ${errorMessageFor(error)}`,
    "Could not retrieve archive backends"
  );
  throw error;
});
const fetchBackend = (backendId) => fetch("GET", url(`/backends/${backendId}`)).catch((error) => {
  UserNotification.error(
    `Fetching archive backend failed: ${errorMessageFor(error)}`,
    "Could not retrieve archive backend"
  );
  throw error;
});
export const saveArchiveBackend = (backend) => {
  const promise = backend.id ? fetch("PUT", url(`/backends/${backend.id}`), backend) : fetch("POST", url("/backends"), backend);
  return promise.then((response) => {
    UserNotification.success("Archive backend was saved successfully");
    return response;
  }).catch((error) => {
    UserNotification.error(
      `Saving archive backend failed: ${errorMessageFor(error)}`,
      "Unable to save archive backend"
    );
    throw error;
  });
};
export const deleteArchiveBackend = (backend, deleteArchives = false) => {
  if (!backend.id) {
    console.log("Tried to delete a backend without id, this should not happen.");
    return Promise.resolve();
  }
  return fetch("DELETE", url(`/backends/${backend.id}?delete_archives=${String(deleteArchives)}`)).then(() => {
    UserNotification.success(`Backend "${backend.title}" deleted`);
  }).catch((error) => {
    UserNotification.error(
      `Backend deletion failed: ${errorMessageFor(error)}`,
      `Could not delete backend: ${backend.title}`
    );
    throw error;
  });
};
export const useInvalidateArchiveBackends = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ARCHIVE_BACKENDS_QUERY_KEY });
};
export const useArchiveBackends = (page, perPage) => useQuery({
  queryKey: [...ARCHIVE_BACKENDS_QUERY_KEY, "paginated", page, perPage],
  queryFn: () => fetchBackends(page, perPage),
  placeholderData: keepPreviousData,
  retry: false
});
export const useArchiveBackend = (backendId) => useQuery({
  queryKey: [...ARCHIVE_BACKEND_QUERY_KEY, backendId],
  queryFn: () => fetchBackend(backendId),
  enabled: !!backendId,
  retry: false
});
